// First: take a reminder's resume token out of the address bar before
// analytics or anything else can read the URL (backend#901).
import "./lib/resumeLink";
// Likewise a shared-assignment `?share=` token, kept for signup attribution (#1054).
import "./lib/shareLink";
// Before anything renders: hands the CSP nonce to the libraries that inject
// <style> elements (#1022).
import "./lib/cspNonce";
import { installSelfHeal } from "./lib/selfHeal";
import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";
// Initialize i18n before the tree renders (#104).
import "./i18n";

// Normally a no-op: the boot script at the top of <head> already installed the
// one-time reload on asset load failures (#917). Covers `npm run dev`, where
// that script is not injected, and a boot script that failed to load itself.
installSelfHeal(window);

const container = document.getElementById("root");

if (!container) {
  throw new Error("Failed to find the root element");
}

const root = createRoot(container);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
